import { ISignMessageController } from "./ISignMessageController";
import { Web3Model } from "../../../../../../web3/models/Web3Model";
import { AsyncOperationNotification } from "../../../../common/components/AsyncOperationNotification";
import { ILogger } from "../../../../../logger/ILogger";
import { inject, injectable } from "@launchtray/tsyringe-async";
import { IAuthModel } from "../../../login/models/IAuthModel";
import { ExternalWalletType } from "../../../../../../web3/externalWallets/ExternalWalletType";
import { AcceptOperationNotification } from "../../../../common/components/AcceptOperationNotification";

@injectable()
export class SignMessageController implements ISignMessageController {
    private readonly web3Model: Web3Model;
    private readonly authModel: IAuthModel;
    private readonly asyncOperationNotification: AsyncOperationNotification;
    private readonly acceptOperationNotification: AcceptOperationNotification;
    private readonly logger: ILogger;

    public constructor(
        web3Model: Web3Model,
        @inject("IAuthModel") authModel: IAuthModel,
        asyncOperationNotification: AsyncOperationNotification,
        acceptOperationNotification: AcceptOperationNotification,
        @inject("ILogger") logger: ILogger
    ) {
        this.web3Model = web3Model;
        this.authModel = authModel;
        this.asyncOperationNotification = asyncOperationNotification;
        this.acceptOperationNotification = acceptOperationNotification;
        this.logger = logger;
    }

    public async signMessage(walletType: ExternalWalletType, address: string): Promise<string> {
        try {
            this.asyncOperationNotification.show();
            const nonce = await this.asyncOperationNotification.autoShowHide(this.authModel.requestWeb3Nonce(address));
            return await this.acceptOperationNotification.autoShowHide(this.web3Model.signExternalWalletMessage(walletType, address, nonce), walletType);
        }
        catch (e: unknown) {
            this.logger.error(`Exception on signing message: `, e);
        }
        return null;
    }
}